import { IconButton, Tooltip } from '@mui/material';
import { Edit, Visibility as VisibilityIcon } from '@mui/icons-material';
import { Fragment, useCallback, ReactElement } from 'react';
import { ActiveTableActions } from 'system/components/shared/list-item-cta-menu/types';
interface DotMenuProps {
  onDetailPress: () => void;
  onEditPress: () => void;
  active?: ActiveTableActions;
  isEdit?: boolean;
}

const ListItemCtaMenu = ({
  onDetailPress,
  onEditPress,
  isEdit,
  active = {
    read: true,
    edit: true,
  },
}: DotMenuProps): ReactElement => {
  const handleEvent = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  return (
    <Fragment>
      <Tooltip
        arrow
        title={
          active.read
            ? 'Visualizza'
            : "Non si ha l'autorizzazione per accedere a questa funzionalità"
        }
      >
        <span>
          {!isEdit ? (
            <IconButton
              onClick={(event) => {
                handleEvent(event);
                onDetailPress();
              }}
              aria-label="Visualizza elemento"
              aria-haspopup="true"
              disabled={!active.read}
              style={{ padding: '4px' }}
            >
              <VisibilityIcon />
            </IconButton>
          ) : undefined}
        </span>
      </Tooltip>
      <Tooltip
        arrow
        title={
          active.edit ? 'Modifica' : "Non si ha l'autorizzazione per accedere a questa funzionalità"
        }
      >
        <span>
          {isEdit ? (
            <IconButton
              aria-label="Modifica elemento"
              aria-haspopup="true"
              onClick={(event) => {
                handleEvent(event);
                onEditPress();
              }}
              disabled={!active.edit}
              style={{ padding: '4px' }}
            >
              <Edit />
            </IconButton>
          ) : undefined}
        </span>
      </Tooltip>
    </Fragment>
  );
};

ListItemCtaMenu.displayName = "List Qualitification's Operator Dot Menu";

export default ListItemCtaMenu;
